import {
  LEAD_TYPE_LIST,
  LEAD_TYPE_LIST_SUCCESS,
  LEAD_TYPE_LIST_FAILURE,
  LEAD_TYPE_DATA,
  LEAD_TYPE_DATA_SUCCESS,
  LEAD_TYPE_DATA_FAILURE,
  LEAD_TYPE_CREATE,
  LEAD_TYPE_CREATE_SUCCESS,
  LEAD_TYPE_CREATE_FAILURE,
  LEAD_TYPE_UPDATE,
  LEAD_TYPE_UPDATE_SUCCESS,
  LEAD_TYPE_UPDATE_FAILURE,
  LEAD_TYPE_DELETE,
  LEAD_TYPE_DELETE_SUCCESS,
  LEAD_TYPE_DELETE_FAILURE,
  LEAD_STATUS_LIST,
  LEAD_STATUS_LIST_SUCCESS,
  LEAD_STATUS_LIST_FAILURE,
  LEAD_STATUS_DATA,
  LEAD_STATUS_DATA_SUCCESS,
  LEAD_STATUS_DATA_FAILURE,
  LEAD_STATUS_CREATE,
  LEAD_STATUS_CREATE_SUCCESS,
  LEAD_STATUS_CREATE_FAILURE,
  LEAD_STATUS_UPDATE,
  LEAD_STATUS_UPDATE_SUCCESS,
  LEAD_STATUS_UPDATE_FAILURE,
  LEAD_STATUS_DELETE,
  LEAD_STATUS_DELETE_SUCCESS,
  LEAD_STATUS_DELETE_FAILURE,
  LEAD_PRIORITY_LIST,
  LEAD_PRIORITY_LIST_SUCCESS,
  LEAD_PRIORITY_LIST_FAILURE,
  LEAD_PRIORITY_DATA,
  LEAD_PRIORITY_DATA_SUCCESS,
  LEAD_PRIORITY_DATA_FAILURE,
  LEAD_PRIORITY_CREATE,
  LEAD_PRIORITY_CREATE_SUCCESS,
  LEAD_PRIORITY_CREATE_FAILURE,
  LEAD_PRIORITY_UPDATE,
  LEAD_PRIORITY_UPDATE_SUCCESS,
  LEAD_PRIORITY_UPDATE_FAILURE,
  LEAD_PRIORITY_DELETE,
  LEAD_PRIORITY_DELETE_SUCCESS,
  LEAD_PRIORITY_DELETE_FAILURE,
  LEAD_NOTE_LIST,
  LEAD_NOTE_LIST_SUCCESS,
  LEAD_NOTE_LIST_FAILURE,
  LEAD_NOTE_SEARCH,
  LEAD_NOTE_SEARCH_SUCCESS,
  LEAD_NOTE_SEARCH_FAILURE,
  LEAD_NOTE_DATA,
  LEAD_NOTE_DATA_SUCCESS,
  LEAD_NOTE_DATA_FAILURE,
  LEAD_NOTE_CREATE,
  LEAD_NOTE_CREATE_SUCCESS,
  LEAD_NOTE_CREATE_FAILURE,
  LEAD_LIST,
  LEAD_LIST_SUCCESS,
  LEAD_LIST_FAILURE,
  LEAD_LIST_UNINVOICED,
  LEAD_LIST_UNINVOICED_SUCCESS,
  LEAD_LIST_UNINVOICED_FAILURE,
  LEAD_OVERVIEW_FUNNEL,
  LEAD_OVERVIEW_FUNNEL_SUCCESS,
  LEAD_OVERVIEW_FUNNEL_FAILURE,
  LEAD_DATA,
  LEAD_DATA_SUCCESS,
  LEAD_DATA_FAILURE,
  LEAD_CREATE,
  LEAD_CREATE_SUCCESS,
  LEAD_CREATE_FAILURE,
  LEAD_UPDATE,
  LEAD_UPDATE_SUCCESS,
  LEAD_UPDATE_FAILURE,
  LEAD_DELETE,
  LEAD_DELETE_SUCCESS,
  LEAD_DELETE_FAILURE,
  LEAD_SEARCH,
  LEAD_SEARCH_SUCCESS,
  LEAD_SEARCH_FAILURE,
  LEAD_TASK_SEARCH,
  LEAD_TASK_SEARCH_SUCCESS,
  LEAD_TASK_SEARCH_FAILURE,
  LEAD_TASK_CREATE,
  LEAD_TASK_CREATE_SUCCESS,
  LEAD_TASK_CREATE_FAILURE,
  LEAD_TASK_TYPE_LIST,
  LEAD_TASK_TYPE_LIST_SUCCESS,
  LEAD_TASK_TYPE_LIST_FAILURE,
  LEAD_TASK_TYPE_DATA,
  LEAD_TASK_TYPE_DATA_SUCCESS,
  LEAD_TASK_TYPE_DATA_FAILURE,
  LEAD_TASK_TYPE_CREATE,
  LEAD_TASK_TYPE_CREATE_SUCCESS,
  LEAD_TASK_TYPE_CREATE_FAILURE,
  LEAD_TASK_TYPE_UPDATE,
  LEAD_TASK_TYPE_UPDATE_SUCCESS,
  LEAD_TASK_TYPE_UPDATE_FAILURE,
  LEAD_TASK_TYPE_DELETE,
  LEAD_TASK_TYPE_DELETE_SUCCESS,
  LEAD_TASK_TYPE_DELETE_FAILURE,
  LEAD_RECENT_ACTIVITY_LIST,
  LEAD_RECENT_ACTIVITY_LIST_SUCCESS,
  LEAD_RECENT_ACTIVITY_LIST_FAILURE,
} from "./actionType";

const initialState = {
  //LEAD_TYPE_LIST
  leadTypeListLoading: false,
  leadTypeList: [],
  leadTypeListError: null,
  //LEAD_TYPE_DATA
  leadTypeDataLoading: false,
  leadTypeData: null,
  leadTypeDataError: null,
  //LEAD_TYPE_CREATE
  leadTypeCreateLoading: false,
  leadTypeCreateSuccess: null,
  leadTypeCreateError: null,
  //LEAD_TYPE_UPDATE
  leadTypeUpdateLoading: false,
  leadTypeUpdateSuccess: null,
  leadTypeUpdateError: null,
  //LEAD_TYPE_DELETE
  leadTypeDeleteLoading: false,
  leadTypeDeleteSuccess: null,
  leadTypeDeleteError: null,
  //LEAD_STATUS_LIST
  leadStatusListLoading: false,
  leadStatusList: [],
  leadStatusListError: null,
  //LEAD_STATUS_DATA
  leadStatusDataLoading: false,
  leadStatusData: null,
  leadStatusDataError: null,
  //LEAD_STATUS_CREATE
  leadStatusCreateLoading: false,
  leadStatusCreateSuccess: null,
  leadStatusCreateError: null,
  //LEAD_STATUS_UPDATE
  leadStatusUpdateLoading: false,
  leadStatusUpdateSuccess: null,
  leadStatusUpdateError: null,
  //LEAD_STATUS_DELETE
  leadStatusDeleteLoading: false,
  leadStatusDeleteSuccess: null,
  leadStatusDeleteError: null,
  //LEAD_PRIORITY_LIST
  leadPriorityListLoading: false,
  leadPriorityList: [],
  leadPriorityListError: null,
  //LEAD_PRIORITY_DATA
  leadPriorityDataLoading: false,
  leadPriorityData: null,
  leadPriorityDataError: null,
  //LEAD_PRIORITY_CREATE
  leadPriorityCreateLoading: false,
  leadPriorityCreateSuccess: null,
  leadPriorityCreateError: null,
  //LEAD_PRIORITY_UPDATE
  leadPriorityUpdateLoading: false,
  leadPriorityUpdateSuccess: null,
  leadPriorityUpdateError: null,
  //LEAD_PRIORITY_DELETE
  leadPriorityDeleteLoading: false,
  leadPriorityDeleteSuccess: null,
  leadPriorityDeleteError: null,
  //LEAD_NOTE_LIST
  leadNoteListLoading: false,
  leadNoteList: [],
  leadNoteListError: null,
  //LEAD_NOTE_SEARCH
  leadNoteSearchLoading: false,
  leadNoteSearchResults: [],
  leadNoteSearchError: null,
  //LEAD_NOTE_DATA
  leadNoteDataLoading: false,
  leadNoteData: null,
  leadNoteDataError: null,
  //LEAD_NOTE_CREATE
  leadNoteCreateLoading: false,
  leadNoteCreateSuccess: null,
  leadNoteCreateError: null,
  //LEAD_LIST
  leadListLoading: false,
  leadList: [],
  leadListError: null,
  //LEAD_LIST_UNINVOICED
  leadListUninvoicedLoading: false,
  leadListUninvoiced: [],
  leadListUninvoicedError: null,
  //LEAD_OVERVIEW_FUNNEL
  leadOverviewFunnelLoading: false,
  leadOverviewFunnel: null,
  leadOverviewFunnelError: null,
  //LEAD_DATA
  leadDataLoading: false,
  leadData: null,
  leadDataError: null,
  //LEAD_CREATE
  leadCreateLoading: false,
  leadCreateSuccess: null,
  leadCreateError: null,
  //LEAD_UPDATE
  leadUpdateLoading: false,
  leadUpdateSuccess: null,
  leadUpdateError: null,
  //LEAD_DELETE
  leadDeleteLoading: false,
  leadDeleteSuccess: null,
  leadDeleteError: null,
  //LEAD_SEARCH
  leadSearchLoading: false,
  leadSearchResults: [],
  leadSearchError: null,
  //LEAD_TASK_SEARCH
  leadTaskSearchLoading: false,
  leadTaskSearchResults: [],
  leadTaskSearchError: null,
  //LEAD_TASK_CREATE
  leadTaskCreateLoading: false,
  leadTaskCreateSuccess: null,
  leadTaskCreateError: null,
  //LEAD_TASK_TYPE_LIST
  leadTaskTypeListLoading: false,
  leadTaskTypeList: [],
  leadTaskTypeListError: null,
  //LEAD_TASK_TYPE_DATA
  leadTaskTypeDataLoading: false,
  leadTaskTypeData: null,
  leadTaskTypeDataError: null,
  //LEAD_TASK_TYPE_CREATE
  leadTaskTypeCreateLoading: false,
  leadTaskTypeCreateSuccess: null,
  leadTaskTypeCreateError: null,
  //LEAD_TASK_TYPE_UPDATE
  leadTaskTypeUpdateLoading: false,
  leadTaskTypeUpdateSuccess: null,
  leadTaskTypeUpdateError: null,
  //LEAD_TASK_TYPE_DELETE
  leadTaskTypeDeleteLoading: false,
  leadTaskTypeDeleteSuccess: null,
  leadTaskTypeDeleteError: null,
  //LEAD_RECENT_ACTIVITY_LIST
  leadRecentActivityListLoading: false,
  leadRecentActivityList: [],
  leadRecentActivityListError: null,
};

const leadsReducer = (state = initialState, action) => {
  switch (action.type) {
    //LEAD_TYPE_LIST
    case LEAD_TYPE_LIST:
      return {
        ...state,
        leadTypeListLoading: true,
        leadTypeListError: null,
      };
    case LEAD_TYPE_LIST_SUCCESS:
      return {
        ...state,
        leadTypeListLoading: false,
        leadTypeList: action.payload,
      };
    case LEAD_TYPE_LIST_FAILURE:
      return {
        ...state,
        leadTypeListLoading: false,
        leadTypeListError: action.payload,
      };
    //LEAD_TYPE_DATA
    case LEAD_TYPE_DATA:
      return {
        ...state,
        leadTypeDataLoading: true,
        leadTypeDataError: null,
      };
    case LEAD_TYPE_DATA_SUCCESS:
      return {
        ...state,
        leadTypeDataLoading: false,
        leadTypeData: action.payload,
      };
    case LEAD_TYPE_DATA_FAILURE:
      return {
        ...state,
        leadTypeDataLoading: false,
        leadTypeDataError: action.payload,
      };
    //LEAD_TYPE_CREATE
    case LEAD_TYPE_CREATE:
      return {
        ...state,
        leadTypeCreateLoading: true,
        leadTypeCreateError: null,
      };
    case LEAD_TYPE_CREATE_SUCCESS:
      return {
        ...state,
        leadTypeCreateLoading: false,
        leadTypeCreateSuccess: action.payload,
      };
    case LEAD_TYPE_CREATE_FAILURE:
      return {
        ...state,
        leadTypeCreateLoading: false,
        leadTypeCreateError: action.payload,
      };
    //LEAD_TYPE_UPDATE
    case LEAD_TYPE_UPDATE:
      return {
        ...state,
        leadTypeUpdateLoading: true,
        leadTypeUpdateError: null,
      };
    case LEAD_TYPE_UPDATE_SUCCESS:
      return {
        ...state,
        leadTypeUpdateLoading: false,
        leadTypeUpdateSuccess: action.payload,
      };
    case LEAD_TYPE_UPDATE_FAILURE:
      return {
        ...state,
        leadTypeUpdateLoading: false,
        leadTypeUpdateError: action.payload,
      };
    //LEAD_TYPE_DELETE
    case LEAD_TYPE_DELETE:
      return {
        ...state,
        leadTypeDeleteLoading: true,
        leadTypeDeleteError: null,
      };
    case LEAD_TYPE_DELETE_SUCCESS:
      return {
        ...state,
        leadTypeDeleteLoading: false,
        leadTypeDeleteSuccess: action.payload,
      };
    case LEAD_TYPE_DELETE_FAILURE:
      return {
        ...state,
        leadTypeDeleteLoading: false,
        leadTypeDeleteError: action.payload,
      };
    //LEAD_STATUS_LIST
    case LEAD_STATUS_LIST:
      return {
        ...state,
        leadStatusListLoading: true,
        leadStatusListError: null,
      };
    case LEAD_STATUS_LIST_SUCCESS:
      return {
        ...state,
        leadStatusListLoading: false,
        leadStatusList: action.payload,
      };
    case LEAD_STATUS_LIST_FAILURE:
      return {
        ...state,
        leadStatusListLoading: false,
        leadStatusListError: action.payload,
      };
    //LEAD_STATUS_DATA
    case LEAD_STATUS_DATA:
      return {
        ...state,
        leadStatusDataLoading: true,
        leadStatusDataError: null,
      };
    case LEAD_STATUS_DATA_SUCCESS:
      return {
        ...state,
        leadStatusDataLoading: false,
        leadStatusData: action.payload,
      };
    case LEAD_STATUS_DATA_FAILURE:
      return {
        ...state,
        leadStatusDataLoading: false,
        leadStatusDataError: action.payload,
      };
    //LEAD_STATUS_CREATE
    case LEAD_STATUS_CREATE:
      return {
        ...state,
        leadStatusCreateLoading: true,
        leadStatusCreateError: null,
      };
    case LEAD_STATUS_CREATE_SUCCESS:
      return {
        ...state,
        leadStatusCreateLoading: false,
        leadStatusCreateSuccess: action.payload,
      };
    case LEAD_STATUS_CREATE_FAILURE:
      return {
        ...state,
        leadStatusCreateLoading: false,
        leadStatusCreateError: action.payload,
      };
    //LEAD_STATUS_UPDATE
    case LEAD_STATUS_UPDATE:
      return {
        ...state,
        leadStatusUpdateLoading: true,
        leadStatusUpdateError: null,
      };
    case LEAD_STATUS_UPDATE_SUCCESS:
      return {
        ...state,
        leadStatusUpdateLoading: false,
        leadStatusUpdateSuccess: action.payload,
      };
    case LEAD_STATUS_UPDATE_FAILURE:
      return {
        ...state,
        leadStatusUpdateLoading: false,
        leadStatusUpdateError: action.payload,
      };
    //LEAD_STATUS_DELETE
    case LEAD_STATUS_DELETE:
      return {
        ...state,
        leadStatusDeleteLoading: true,
        leadStatusDeleteError: null,
      };
    case LEAD_STATUS_DELETE_SUCCESS:
      return {
        ...state,
        leadStatusDeleteLoading: false,
        leadStatusDeleteSuccess: action.payload,
      };
    case LEAD_STATUS_DELETE_FAILURE:
      return {
        ...state,
        leadStatusDeleteLoading: false,
        leadStatusDeleteError: action.payload,
      };
    //LEAD_PRIORITY_LIST
    case LEAD_PRIORITY_LIST:
      return {
        ...state,
        leadPriorityListLoading: true,
        leadPriorityListError: null,
      };
    case LEAD_PRIORITY_LIST_SUCCESS:
      return {
        ...state,
        leadPriorityListLoading: false,
        leadPriorityList: action.payload,
      };
    case LEAD_PRIORITY_LIST_FAILURE:
      return {
        ...state,
        leadPriorityListLoading: false,
        leadPriorityListError: action.payload,
      };
    //LEAD_PRIORITY_DATA
    case LEAD_PRIORITY_DATA:
      return {
        ...state,
        leadPriorityDataLoading: true,
        leadPriorityDataError: null,
      };
    case LEAD_PRIORITY_DATA_SUCCESS:
      return {
        ...state,
        leadPriorityDataLoading: false,
        leadPriorityData: action.payload,
      };
    case LEAD_PRIORITY_DATA_FAILURE:
      return {
        ...state,
        leadPriorityDataLoading: false,
        leadPriorityDataError: action.payload,
      };
    //LEAD_PRIORITY_CREATE
    case LEAD_PRIORITY_CREATE:
      return {
        ...state,
        leadPriorityCreateLoading: true,
        leadPriorityCreateError: null,
      };
    case LEAD_PRIORITY_CREATE_SUCCESS:
      return {
        ...state,
        leadPriorityCreateLoading: false,
        leadPriorityCreateSuccess: action.payload,
      };
    case LEAD_PRIORITY_CREATE_FAILURE:
      return {
        ...state,
        leadPriorityCreateLoading: false,
        leadPriorityCreateError: action.payload,
      };
    //LEAD_PRIORITY_UPDATE
    case LEAD_PRIORITY_UPDATE:
      return {
        ...state,
        leadPriorityUpdateLoading: true,
        leadPriorityUpdateError: null,
      };
    case LEAD_PRIORITY_UPDATE_SUCCESS:
      return {
        ...state,
        leadPriorityUpdateLoading: false,
        leadPriorityUpdateSuccess: action.payload,
      };
    case LEAD_PRIORITY_UPDATE_FAILURE:
      return {
        ...state,
        leadPriorityUpdateLoading: false,
        leadPriorityUpdateError: action.payload,
      };
    //LEAD_PRIORITY_DELETE
    case LEAD_PRIORITY_DELETE:
      return {
        ...state,
        leadPriorityDeleteLoading: true,
        leadPriorityDeleteError: null,
      };
    case LEAD_PRIORITY_DELETE_SUCCESS:
      return {
        ...state,
        leadPriorityDeleteLoading: false,
        leadPriorityDeleteSuccess: action.payload,
      };
    case LEAD_PRIORITY_DELETE_FAILURE:
      return {
        ...state,
        leadPriorityDeleteLoading: false,
        leadPriorityDeleteError: action.payload,
      };
    //LEAD_NOTE_LIST
    case LEAD_NOTE_LIST:
      return {
        ...state,
        leadNoteListLoading: true,
        leadNoteListError: null,
      };
    case LEAD_NOTE_LIST_SUCCESS:
      return {
        ...state,
        leadNoteListLoading: false,
        leadNoteList: action.payload,
      };
    case LEAD_NOTE_LIST_FAILURE:
      return {
        ...state,
        leadNoteListLoading: false,
        leadNoteListError: action.payload,
      };
    //LEAD_NOTE_SEARCH
    case LEAD_NOTE_SEARCH:
      return {
        ...state,
        leadNoteSearchLoading: true,
        leadNoteSearchError: null,
      };
    case LEAD_NOTE_SEARCH_SUCCESS:
      return {
        ...state,
        leadNoteSearchLoading: false,
        leadNoteSearchResults: action.payload,
      };
    case LEAD_NOTE_SEARCH_FAILURE:
      return {
        ...state,
        leadNoteSearchLoading: false,
        leadNoteSearchError: action.payload,
      };
    //LEAD_NOTE_DATA
    case LEAD_NOTE_DATA:
      return {
        ...state,
        leadNoteDataLoading: true,
        leadNoteDataError: null,
      };
    case LEAD_NOTE_DATA_SUCCESS:
      return {
        ...state,
        leadNoteDataLoading: false,
        leadNoteData: action.payload,
      };
    case LEAD_NOTE_DATA_FAILURE:
      return {
        ...state,
        leadNoteDataLoading: false,
        leadNoteDataError: action.payload,
      };
    //LEAD_NOTE_CREATE
    case LEAD_NOTE_CREATE:
      return {
        ...state,
        leadNoteCreateLoading: true,
        leadNoteCreateError: null,
      };
    case LEAD_NOTE_CREATE_SUCCESS:
      return {
        ...state,
        leadNoteCreateLoading: false,
        leadNoteCreateSuccess: action.payload,
      };
    case LEAD_NOTE_CREATE_FAILURE:
      return {
        ...state,
        leadNoteCreateLoading: false,
        leadNoteCreateError: action.payload,
      };
    //LEAD_LIST
    case LEAD_LIST:
      return {
        ...state,
        leadListLoading: true,
        leadListError: null,
      };
    case LEAD_LIST_SUCCESS:
      return {
        ...state,
        leadListLoading: false,
        leadList: action.payload,
      };
    case LEAD_LIST_FAILURE:
      return {
        ...state,
        leadListLoading: false,
        leadListError: action.payload,
      };
    //LEAD_LIST_UNINVOICED
    case LEAD_LIST_UNINVOICED:
      return {
        ...state,
        leadListUninvoicedLoading: true,
        leadListUninvoicedError: null,
      };
    case LEAD_LIST_UNINVOICED_SUCCESS:
      return {
        ...state,
        leadListUninvoicedLoading: false,
        leadListUninvoiced: action.payload,
      };
    case LEAD_LIST_UNINVOICED_FAILURE:
      return {
        ...state,
        leadListUninvoicedLoading: false,
        leadListUninvoicedError: action.payload,
      };
    //LEAD_OVERVIEW_FUNNEL
    case LEAD_OVERVIEW_FUNNEL:
      return {
        ...state,
        leadOverviewFunnelLoading: true,
        leadOverviewFunnelError: null,
      };
    case LEAD_OVERVIEW_FUNNEL_SUCCESS:
      return {
        ...state,
        leadOverviewFunnelLoading: false,
        leadOverviewFunnel: action.payload,
      };
    case LEAD_OVERVIEW_FUNNEL_FAILURE:
      return {
        ...state,
        leadOverviewFunnelLoading: false,
        leadOverviewFunnelError: action.payload,
      };
    //LEAD_DATA
    case LEAD_DATA:
      return {
        ...state,
        leadDataLoading: true,
        leadDataError: null,
      };
    case LEAD_DATA_SUCCESS:
      return {
        ...state,
        leadDataLoading: false,
        leadData: action.payload,
      };
    case LEAD_DATA_FAILURE:
      return {
        ...state,
        leadDataLoading: false,
        leadDataError: action.payload,
      };
    //LEAD_CREATE
    case LEAD_CREATE:
      return {
        ...state,
        leadCreateLoading: true,
        leadCreateError: null,
      };
    case LEAD_CREATE_SUCCESS:
      return {
        ...state,
        leadCreateLoading: false,
        leadCreateSuccess: action.payload,
      };
    case LEAD_CREATE_FAILURE:
      return {
        ...state,
        leadCreateLoading: false,
        leadCreateError: action.payload,
      };
    //LEAD_UPDATE
    case LEAD_UPDATE:
      return {
        ...state,
        leadUpdateLoading: true,
        leadUpdateError: null,
      };
    case LEAD_UPDATE_SUCCESS:
      return {
        ...state,
        leadUpdateLoading: false,
        leadUpdateSuccess: action.payload,
      };
    case LEAD_UPDATE_FAILURE:
      return {
        ...state,
        leadUpdateLoading: false,
        leadUpdateError: action.payload,
      };
    //LEAD_DELETE
    case LEAD_DELETE:
      return {
        ...state,
        leadDeleteLoading: true,
        leadDeleteError: null,
      };
    case LEAD_DELETE_SUCCESS:
      return {
        ...state,
        leadDeleteLoading: false,
        leadDeleteSuccess: action.payload,
      };
    case LEAD_DELETE_FAILURE:
      return {
        ...state,
        leadDeleteLoading: false,
        leadDeleteError: action.payload,
      };
    //LEAD_SEARCH
    case LEAD_SEARCH:
      return {
        ...state,
        leadSearchLoading: true,
        leadSearchError: null,
      };
    case LEAD_SEARCH_SUCCESS:
      return {
        ...state,
        leadSearchLoading: false,
        leadSearchResults: action.payload,
      };
    case LEAD_SEARCH_FAILURE:
      return {
        ...state,
        leadSearchLoading: false,
        leadSearchError: action.payload,
      };
    //LEAD_TASK_SEARCH
    case LEAD_TASK_SEARCH:
      return {
        ...state,
        leadTaskSearchLoading: true,
        leadTaskSearchError: null,
      };
    case LEAD_TASK_SEARCH_SUCCESS:
      return {
        ...state,
        leadTaskSearchLoading: false,
        leadTaskSearchResults: action.payload,
      };
    case LEAD_TASK_SEARCH_FAILURE:
      return {
        ...state,
        leadTaskSearchLoading: false,
        leadTaskSearchError: action.payload,
      };
    //LEAD_TASK_CREATE
    case LEAD_TASK_CREATE:
      return {
        ...state,
        leadTaskCreateLoading: true,
        leadTaskCreateError: null,
      };
    case LEAD_TASK_CREATE_SUCCESS:
      return {
        ...state,
        leadTaskCreateLoading: false,
        leadTaskCreateSuccess: action.payload,
      };
    case LEAD_TASK_CREATE_FAILURE:
      return {
        ...state,
        leadTaskCreateLoading: false,
        leadTaskCreateError: action.payload,
      };
    //LEAD_TASK_TYPE_LIST
    case LEAD_TASK_TYPE_LIST:
      return {
        ...state,
        leadTaskTypeListLoading: true,
        leadTaskTypeListError: null,
      };
    case LEAD_TASK_TYPE_LIST_SUCCESS:
      return {
        ...state,
        leadTaskTypeListLoading: false,
        leadTaskTypeList: action.payload,
      };
    case LEAD_TASK_TYPE_LIST_FAILURE:
      return {
        ...state,
        leadTaskTypeListLoading: false,
        leadTaskTypeListError: action.payload,
      };
    //LEAD_TASK_TYPE_DATA
    case LEAD_TASK_TYPE_DATA:
      return {
        ...state,
        leadTaskTypeDataLoading: true,
        leadTaskTypeDataError: null,
      };
    case LEAD_TASK_TYPE_DATA_SUCCESS:
      return {
        ...state,
        leadTaskTypeDataLoading: false,
        leadTaskTypeData: action.payload,
      };
    case LEAD_TASK_TYPE_DATA_FAILURE:
      return {
        ...state,
        leadTaskTypeDataLoading: false,
        leadTaskTypeDataError: action.payload,
      };
    //LEAD_TASK_TYPE_CREATE
    case LEAD_TASK_TYPE_CREATE:
      return {
        ...state,
        leadTaskTypeCreateLoading: true,
        leadTaskTypeCreateError: null,
      };
    case LEAD_TASK_TYPE_CREATE_SUCCESS:
      return {
        ...state,
        leadTaskTypeCreateLoading: false,
        leadTaskTypeCreateSuccess: action.payload,
      };
    case LEAD_TASK_TYPE_CREATE_FAILURE:
      return {
        ...state,
        leadTaskTypeCreateLoading: false,
        leadTaskTypeCreateError: action.payload,
      };
    //LEAD_TASK_TYPE_UPDATE
    case LEAD_TASK_TYPE_UPDATE:
      return {
        ...state,
        leadTaskTypeUpdateLoading: true,
        leadTaskTypeUpdateError: null,
      };
    case LEAD_TASK_TYPE_UPDATE_SUCCESS:
      return {
        ...state,
        leadTaskTypeUpdateLoading: false,
        leadTaskTypeUpdateSuccess: action.payload,
      };
    case LEAD_TASK_TYPE_UPDATE_FAILURE:
      return {
        ...state,
        leadTaskTypeUpdateLoading: false,
        leadTaskTypeUpdateError: action.payload,
      };
    //LEAD_TASK_TYPE_DELETE
    case LEAD_TASK_TYPE_DELETE:
      return {
        ...state,
        leadTaskTypeDeleteLoading: true,
        leadTaskTypeDeleteError: null,
      };
    case LEAD_TASK_TYPE_DELETE_SUCCESS:
      return {
        ...state,
        leadTaskTypeDeleteLoading: false,
        leadTaskTypeDeleteSuccess: action.payload,
      };
    case LEAD_TASK_TYPE_DELETE_FAILURE:
      return {
        ...state,
        leadTaskTypeDeleteLoading: false,
        leadTaskTypeDeleteError: action.payload,
      };
    //LEAD_RECENT_ACTIVITY_LIST
    case LEAD_RECENT_ACTIVITY_LIST:
      return {
        ...state,
        leadRecentActivityListLoading: true,
        leadRecentActivityListError: null,
      };
    case LEAD_RECENT_ACTIVITY_LIST_SUCCESS:
      return {
        ...state,
        leadRecentActivityListLoading: false,
        leadRecentActivityList: action.payload,
      };
    case LEAD_RECENT_ACTIVITY_LIST_FAILURE:
      return {
        ...state,
        leadRecentActivityListLoading: false,
        leadRecentActivityListError: action.payload,
      };

    default:
      return state;
  }
};

export default leadsReducer;